"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _isomorphicFetch = _interopRequireDefault(require("isomorphic-fetch"));

var _moment = _interopRequireDefault(require("moment"));

var _chance = _interopRequireDefault(require("chance"));

var _ewoloConstants = _interopRequireDefault(require("./ewoloConstants"));

var _RequestError = _interopRequireDefault(require("./RequestError"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// import ReactDOM from "react-dom";
var wrapLocalStorageAccess = function wrapLocalStorageAccess(fn) {
  try {
    return fn();
  } catch (e) {
    if (e && e.name === "SecurityError") {
      console.log("Please enable cookies to be auto logged-in");
    } else {
      console.error(e);
    }
  }
};

var ewoloUtil = {
  getApiRequest: function getApiRequest(_ref) {
    var route = _ref.route,
        method = _ref.method,
        body = _ref.body,
        authToken = _ref.authToken;
    var url = _ewoloConstants["default"].api.url + route;
    var headers = {
      "Content-Type": "application/json"
    };
    headers[_ewoloConstants["default"].api.apiKeyHeader] = _ewoloConstants["default"].api.apiKey;

    if (authToken) {
      headers[_ewoloConstants["default"].api.authorizationHeader] = "Bearer " + authToken;
    }

    var options = {
      method: method,
      headers: headers
    };

    if (body) {
      options.body = JSON.stringify(body);
    }

    return (0, _isomorphicFetch["default"])(url, options);
  },
  getApiResponse: function getApiResponse(response) {
    if (response.status >= 400) {
      throw new _RequestError["default"](response);
    }

    if (response.status === 200 || response.status === 201) {
      return response.json();
    }

    return response.status;
  },
  getApiResponseStatus: function getApiResponseStatus(response) {
    if (response.status >= 400) {
      throw new _RequestError["default"](response);
    }

    return Promise.resolve(response.status);
  },
  validateEmail: function validateEmail(email) {
    if (!email) {
      return "Email is required.";
    }

    return "";
  },
  validateRequired: function validateRequired(str, name) {
    if (!str) {
      return "".concat(name, " is required.");
    }

    return "";
  },
  validatePassword: function validatePassword(password) {
    if (!password) {
      return "Password is required.";
    }

    if (password.length < 8) {
      return "Password must be minimum 8 characters in length.";
    }

    return "";
  },
  // Note that stringify and parse may block the main thread
  // Also, consider using cookies for auth token storage: https://stormpath.com/blog/where-to-store-your-jwts-cookies-vs-html5-web-storage
  storeObject: function storeObject(key, obj) {
    var fn = function fn() {
      if (window.localStorage) {
        window.localStorage.setItem(key, JSON.stringify(obj));
      }
    };

    return wrapLocalStorageAccess(fn);
  },
  getObject: function getObject(key) {
    var fn = function fn() {
      if (window.localStorage) {
        var value = window.localStorage.getItem(key);

        if (value) {
          return JSON.parse(value);
        }
      }

      return null;
    };

    return wrapLocalStorageAccess(fn);
  },
  removeObject: function removeObject(key) {
    var fn = function fn() {
      if (window.localStorage) {
        window.localStorage.removeItem(key);
      }
    };

    return wrapLocalStorageAccess(fn);
  },
  getTodaysDate: function getTodaysDate() {
    return (0, _moment["default"])().format("YYYY-MM-DD");
  },

  /*
  scrollElementIntoView: element => {
    setTimeout(() => {
      ReactDOM.findDOMNode(element).scrollIntoView({
        block: "end",
        behavior: "smooth"
      });
    }, 0);
  },
  */
  chance: new _chance["default"](),
  unitsToText: function unitsToText(units) {
    if (units === 1) {
      return "lbs";
    }

    return "kgs";
  },
  textToSex: function textToSex(sex) {
    if (sex === "male") {
      return 2;
    }

    if (sex === "female") {
      return 3;
    }

    return 1;
  },
  isMobileDevice: function isMobileDevice() {
    return window.innerWidth < 600;
  },
  getWindowWidth: function getWindowWidth() {
    var w = window,
        d = document,
        documentElement = d.documentElement,
        body = d.getElementsByTagName("body")[0],
        width = w.innerWidth || documentElement.clientWidth || body.clientWidth;
    return width;
  },
  setCursorAtEndOnFocus: function setCursorAtEndOnFocus(e) {
    var val = e.target.value;
    e.target.value = "";
    e.target.value = val;
  },
  noOp: function noOp() {}
};
var _default = ewoloUtil;
exports["default"] = _default;